export default {
    title: "Our customers achieve more",
    theme: "light",
    withGetStarted: true,
    ctaText: "Get started",
    stories: [
        {
            type: "quote",
            backgroundColor: "#000000",
            textColor: "#FFFFFF",
            quoteColor: "#FE81E4",
            quote: "We replaced a 15-minute screening call with <b>an AI agent</b> that does it <b>in 5 minutes.</b>",
            author: "Alex Boulder",
            role: "Director of Operations",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1780489572/Pricing%20page%20-%20new/PricingpagewithAI-Container01-rfp41.jpg",
                alt: ""
            }
        },
        {
            type: "stat",
            backgroundColor: "#DED4FC",
            statValue: "40%",
            statLabel: "Faster production time",
            industry: "Technology",
            industryTagColor: "#FFFFFF",
            ctaText: "Read the case study",
            ctaHref: "https://monday.com/w/customer-stories/mcdonalds",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1780489572/Pricing%20page%20-%20new/PricingpagewithAI-Container03-ogrGM.jpg",
                alt: ""
            }
        },
        {
            type: "stat",
            backgroundColor: "#F4CDFF",
            statValue: "25%",
            statLabel: "Reduction in project timelines",
            industry: "Retail and CPG",
            industryTagColor: "#FFFFFF",
            ctaText: "Read the case study",
            ctaHref: "https://monday.com/w/customer-stories/canva",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1780489573/Pricing%20page%20-%20new/PricingpagewithAI-Container02-23oDn.jpg",
                alt: ""
            }
        },
        {
            type: "quote",
            backgroundColor: "#FD84E2",
            textColor: "#FFFFFF",
            quoteColor: "#FE81E4",
            quote: "It's the first time we've seen a real <b>AI solution</b> that is <b>actually useful.</b>",
            author: "Alex Boulder",
            role: "Director of Operations",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1780489572/Pricing%20page%20-%20new/PricingpagewithAI-Container04-FJi4z.jpg",
                alt: ""
            }
        },
        {
            type: "stat",
            backgroundColor: "#FFF0C8",
            statValue: "105K",
            statLabel: "Hours saved annually",
            industry: "Technology",
            industryTagColor: "#FFFFFF",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1780489572/Pricing%20page%20-%20new/PricingpagewithAI-Container05-bXK8v.jpg",
                alt: ""
            }
        },
        {
            type: "stat",
            backgroundColor: "#4B00D7",
            textColor: "#FFFFFF",
            statValue: "517%",
            statLabel: "Growth in annual accounts",
            industry: "Retail and CPG",
            industryTagColor: "#FFFFFF",
            industryTagTextColor: "#000000",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1780489572/Pricing%20page%20-%20new/PricingpagewithAI-Container06-DRPv6.jpg",
                alt: ""
            }
        },
        {
            type: "stat",
            backgroundColor: "#1AD5FF",
            statValue: "$250K",
            statLabel: "Saved yearly to reinvest",
            industry: "Advertising",
            industryTagColor: "#FFFFFF",
            ctaText: "Read the case study",
            ctaHref: "https://monday.com/w/customer-stories/vml",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1780489572/Pricing%20page%20-%20new/PricingpagewithAI-Container07-VYQ0P.jpg",
                alt: ""
            }
        }
    ]
};
